export const legalOnboardingHeaderElements = [
    { label: "CUIT/CUIL", value: "cuitCuil" },
    { label: "Tipo Sociedad", value: "tipoSociedad" },
    { label: "Razón social", value: "razonSocial" },
    { label: "Estado", value: "estado" },
  ];